import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DataTablesModule} from 'angular-datatables';
import {CounterComponent} from './widgets/counter.component';
import {DatagridComponent} from './datagrid/datagrid.component';
import {TeamMemberComponent} from './team-member/team-member.component';

@NgModule({
    imports: [
        DataTablesModule,
        CommonModule
    ],
    declarations: [DatagridComponent, CounterComponent, TeamMemberComponent],
    exports: [
        DatagridComponent,
        CounterComponent,
        TeamMemberComponent
    ]

})
export class UiModule {
}
